import { cn } from '@/shared/lib';
import type { BadgeProps } from './types';
import { badgeIconStyles, badgeStyles } from './styles';

export type { BadgeProps, BadgeTone } from './types';

/**
 * Non-interactive status pill.
 *
 * A `<span>`, not a `<button>`: a badge displays state and is never activated.
 * Rendering it as a control would put a dead target in the tab order.
 *
 * The tone never travels alone. `children` is required, and callers pair a
 * status word with the colour — see `BadgeProps`.
 */
export function Badge({ tone, icon: Icon, className, children, ...rest }: BadgeProps) {
  return (
    <span {...rest} className={cn(badgeStyles({ tone }), className)}>
      {Icon ? <Icon aria-hidden="true" className={badgeIconStyles} /> : null}
      {children}
    </span>
  );
}